export default __webpack_public_path__ + "static/media/activate.192aa663.svg";